export var getPerformanceTimeout = function (performance, performanceTimeout) {
    if (performanceTimeout)
        return performanceTimeout;
    var _performanceTimeout = {
        off: 0,
        debounce: 300,
        throttle: 750,
    };
    return _performanceTimeout[performance];
};
